import { ArsenalHeader } from '@components/arsenal/ArsenalHeader';
import { ForgeItem } from '@components/arsenal/forge/ForgeItem';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';

export function ArsenalForge() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Forge' });
  const { userData } = useAppStore();

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <ArsenalHeader description={t('description')} title={t('title')} bg="forge.avif" />

      <div className="flex-1 bg-black overflow-y-auto">
        {userData.blueprints.map((item, index) => (
          <ForgeItem type={item.type as any} amount={item.amount} value={item.key} key={index} />
        ))}

        {userData.blueprints.length === 0 && (
          <div className="text-center text-sm text-gray-300 p-4">
            {t('empty')}
          </div>
        )}
      </div>
    </div>
  );
}